import React, { useState } from "react";
import { 
	Dialog, 
	DialogContent, 
	Button, 
	Typography, 
	Box,
	IconButton
} from "@material-ui/core";
import { Close as CloseIcon, Warning as WarningIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const ExpiredLinkModal = ({ 
	open, 
	onClose, 
	newLink,
	businessName,
    support = false
}) => {
	const { t } = useTranslation();
	const [copied, setCopied] = useState(false);

	const handleCopyLink = async () => {
		if (!newLink) return;
		try {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(newLink);
			} else {
				const temp = document.createElement("textarea");
				temp.value = newLink;
				document.body.appendChild(temp);
				temp.select();
				document.execCommand("copy");
				document.body.removeChild(temp);
			}
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		} catch (e) {
			// no-op; silent fail to avoid UX interruption
		}
	};

	const handleGoToSupport = () => {
		const raw = [t("supportExpiredLinkMessage")].join("\n");
		const message = encodeURIComponent(raw);
		const link = `https://wa.me/?text=${message}`;
		window.open(link, "_blank");
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{
				style: { 
					borderRadius: 20, 
					maxWidth: 500, 
					width: "90%",
					margin: 16,
					backgroundColor: "#FFFFFF"
				},
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(0, 0, 0, 0.5)",
					backdropFilter: "blur(8px)"
				}
			}}
		>
			<DialogContent style={{ padding: "32px 24px", textAlign: "center", position: "relative" }}>
				<IconButton
					onClick={onClose}
					style={{
						position: "absolute",
						top: 16,
						right: 16,
						color: "#666"
					}}
				>
					<CloseIcon />
				</IconButton>

				<Box style={{ marginBottom: 24 }}>
					<WarningIcon style={{ color: "#F1C40F", fontSize: 64 }} />
				</Box>

				<Typography
					variant="h5"
					style={{
						fontWeight: 700,
						color: "#1A1A2E",
						marginBottom: 16,
						fontSize: "24px",
						lineHeight: 1.2
					}}
				>
					{t("Expired link")}
				</Typography>

				<Typography
					variant="body1"
					style={{
						color: "#666666",
						marginBottom: 24,
						fontSize: "16px",
						lineHeight: 1.5
					}}
				>
					{t("This link has been replaced to provide a safer updated experience")}
				</Typography>

				{businessName && (
					<Typography
						variant="h6"
						style={{
							color: "#1A1A2E",
							marginBottom: 16,
							fontSize: "18px",
							fontWeight: 600
						}}
					>
						{businessName}
					</Typography>
				)}

				{newLink ? (
					<Box
						style={{
							backgroundColor: "#FFF8E1",
							border: "1px solid #FFE082",
							borderRadius: 12,
							padding: 20,
							marginBottom: 24,
							textAlign: "left"
						}}
					>
						<Typography
							variant="subtitle1"
							style={{
								fontWeight: 700,
								color: "#5D4037",
								marginBottom: 8
							}}
						>
							{t("The old link has expired")}
						</Typography>
						<Typography
							variant="body2"
							style={{
								color: "#5D4037",
								marginBottom: 16,
								lineHeight: 1.4
							}}
						>
							{t("Use the new link below to continue your booking")}
						</Typography>
						
						<Box
							style={{
								backgroundColor: "#FFFFFF",
								border: "1px solid #E0E0E0",
								borderRadius: 8,
								padding: "12px 16px",
								marginBottom: 16,
								wordBreak: "break-all"
							}}
						>
							<Typography
								variant="body2"
								style={{
									color: "#333",
									fontSize: "14px",
									fontFamily: "monospace"
								}}
							>
								{newLink}
							</Typography>
						</Box>

						<Button
							onClick={handleCopyLink}
							variant="contained"
							style={{
								backgroundColor: "#450067",
								color: "#FFFFFF",
								width: "100%",
								height: 44,
								borderRadius: 12,
								fontSize: "16px",
								fontWeight: 600,
								textTransform: "none"
							}}
						>
							{copied ? t("Copied") : t("Copy Link")}
						</Button>
					</Box>
				) : (
					<Box
						style={{
							backgroundColor: "#FFF8E1",
							border: "1px solid #FFE082",
							borderRadius: 12,
							padding: 20,
							marginBottom: 24
						}}
					>
						<Typography
							variant="body2"
							style={{
								color: "#5D4037",
								lineHeight: 1.4
							}}
						>
							{t("Please ask the business directly for a new link to continue with your booking")}
						</Typography>
					</Box>
				)}
                {support && (
                    <Button
                        onClick={handleGoToSupport}
                        variant="contained"
                        style={{
                            backgroundColor: "#27AE60",
                            color: "#FFFFFF",
                            width: "100%",
                            height: 44,
                            borderRadius: 12,
                            fontSize: "16px",
                            fontWeight: 600,
                            textTransform: "none"
                        }}
                    >
                        {t("Talk to the business")}
                    </Button>
                )}    
			</DialogContent>
		</Dialog>
	);
};

export default ExpiredLinkModal;
